module.exports = __webpack_public_path__ + "static/media/icon_monitor.56f4c8a5.svg";